export const skillsData = {
  languages: [
    {
      title: "JavaScript",
      icon: "logos:javascript",
      text: "JavaScript é a linguagem de programação essencial para desenvolvimento web, permitindo interatividade e dinamismo.",
      url: "https://developer.mozilla.org/pt-BR/docs/Web/JavaScript",
    },
    {
      title: "TypeScript",
      icon: "logos:typescript-icon",
      text: "TypeScript é um superconjunto do JavaScript que adiciona tipagem estática para maior segurança e produtividade.",
      url: "https://www.typescriptlang.org/",
    },
    {
      title: "C#",
      icon: "devicon:csharp",
      text: "O C# é uma linguagem de programação moderna, inovadora e amplamente usada no ambiente empresarial.",
      url: "https://dotnet.microsoft.com/pt-br/languages/csharp",
    },
  ],
  frameworks: [
    {
      title: "Electron",
      icon: "logos:electron",
      text: "Electron é um framework para construção de aplicações desktop usando tecnologias web.",
      url: "https://www.electronjs.org/",
    },
    {
      title: "React",
      icon: "devicon:react",
      text: "React é uma biblioteca JavaScript para construção de interfaces de usuário dinâmicas e eficientes.",
      url: "https://react.dev/",
    },
    {
      title: "Next.js",
      icon: "logos:nextjs-icon",
      text: "Next.js é um framework React para desenvolvimento de aplicações web otimizadas e escaláveis.",
      url: "https://nextjs.org/",
    },
    {
      title: ".NET",
      icon: "logos:dotnet",
      text: ".NET é uma plataforma de desenvolvimento para construção de diversos tipos de aplicações.",
      url: "https://dotnet.microsoft.com/pt-br/",
    },
    {
      title: "Entity Framework Core",
      icon: "logos:dotnet",
      text: "Entity Framework Core é um ORM moderno para .NET, facilitando a comunicação entre aplicações e bancos de dados.",
      url: "https://learn.microsoft.com/pt-br/ef/core/",
    },
    {
      title: "Camunda BPM",
      icon: "simple-icons:camunda",
      text: "Camunda é uma plataforma de automação de processos e orquestração de fluxos de trabalho baseada em BPMN.",
      url: "https://camunda.com/",
    },
  ],
  frontend: [
    {
      title: "HTML",
      icon: "vscode-icons:file-type-html",
      text: "HTML5 é a versão mais recente do HTML, permitindo a criação de páginas web modernas e responsivas.",
      url: "https://developer.mozilla.org/pt-BR/docs/Web/HTML",
    },
    {
      title: "CSS",
      icon: "vscode-icons:file-type-css",
      text: "CSS é a linguagem de estilos que controla a aparência e o layout de páginas web.",
      url: "https://developer.mozilla.org/pt-BR/docs/Web/CSS",
    },
    {
      title: "Tailwind CSS",
      icon: "logos:tailwindcss-icon",
      text: "Tailwind CSS é um framework de estilos utilitário que facilita o desenvolvimento de interfaces modernas e responsivas.",
      url: "https://tailwindcss.com/",
    },
  ],
  databases: [
    {
      title: "SQL Server",
      icon: "devicon-plain:microsoftsqlserver-wordmark",
      text: "O Microsoft SQL Server é um sistema de banco de dados relacional desenvolvido pela Microsoft.",
      url: "https://www.microsoft.com/sql-server",
    },
    {
      title: "MySQL",
      icon: "logos:mysql",
      text: "MySQL é um dos sistemas de gerenciamento de banco de dados mais populares do mundo, amplamente usado em aplicações web.",
      url: "https://www.mysql.com/",
    },
    {
      title: "PostgreSQL",
      icon: "devicon:postgresql",
      text: "PostgreSQL é um banco de dados relacional open-source avançado, conhecido por sua confiabilidade e extensibilidade.",
      url: "https://www.postgresql.org/",
    },
    {
      title: "SQLite",
      icon: "skill-icons:sqlite",
      text: "SQLite é um banco de dados relacional leve e embutido, amplamente usado em aplicações locais e móveis.",
      url: "https://www.sqlite.org/",
    },
    {
      title: "Elasticsearch",
      icon: "vscode-icons:file-type-elastic",
      text: "Elasticsearch é um motor de busca e análise distribuído, ideal para lidar com grandes volumes de dados em tempo real.",
      url: "https://www.elastic.co/pt/elasticsearch/",
    },
  ],

  platforms: [
    {
      title: "Node.js",
      icon: "logos:nodejs-icon-alt",
      text: "Node.js é um ambiente de execução JavaScript assíncrono e orientado a eventos, ideal para servidores escaláveis.",
      url: "https://nodejs.org/",
    },
    {
      title: "Docker",
      icon: "logos:docker-icon",
      text: "Docker é uma plataforma que permite criar, testar e implantar aplicações rapidamente em containers isolados.",
      url: "https://www.docker.com/",
    },
  ],
  versionControl: [
    {
      title: "Git",
      icon: "devicon:git",
      text: "Git é um sistema de controle de versão distribuído amplamente utilizado para desenvolvimento colaborativo.",
      url: "https://git-scm.com/",
    },
    {
      title: "GitHub",
      icon: "mdi:github",
      text: "GitHub é uma plataforma de hospedagem de código-fonte com controle de versão usando o Git.",
      url: "https://github.com/",
    },
    {
      title: "TortoiseSVN",
      icon: "devicon:tortoisegit",
      text: "TortoiseSVN é um cliente Subversion para controle de versão, integrado ao Windows Explorer.",
      url: "https://tortoisesvn.net/",
    },
  ],
};
